const AquaaURLs = (name,items) => {
    switch (name) {
      case 'GET_AQUAA_ACCOUNTS_DATA':  {
        return `/api/usp/AquAAGetAccountsByEvaluator`;
      }
      case 'GET_AQUAA_AGENTS_DATA':  {
        return `/api/usp/AquAAGetAgentsByAccountEvaluator?AccountID=${items.account}&Location=${items.location}&ContactFormID=${items.channel}`;
      }
      case 'GET_AQUAA_CHANNELS_DATA':  {
        return `/api/usp/AquAAGetChannelsByAgentAccountEvaluator?AccountID=${items.account}&Location=${items.location}`;
      }
      case 'GET_AQUAA_LANGUAGES_DATA':  {
        return `/api/usp/AquAAGetLanguages?AccountID=${items.account}&Agent=${items.agent}&Channel=${items.channel}&Location=${items.location}`;
      }
      case 'GET_AQUAA_LOCATIONS_DATA':  {
        return `/api/usp/AquAAGetSites?AccountID=${items.account}`;
      }
      case 'GET_AQUAA_VALIDFROM_DATA':  {
        return `/api/usp/AQuAAGetFromDate`;
      }
      case 'GET_AQUAA_MARKETGROUP_DATA':  {
        return `/api/usp/AQuAAGetMarketGroups?AccountID=${items.account}`;
      }
      case 'GET_AQUAA_AWS_DATA':  {
        return `/api/usp/AquAAGetAWSData?AccountID=${items.account}&Agent=${items.agent}&Channel=${items.channel}&Language=${items.language}&Location=${items.location}&From=${items.from}&To=${items.to}`;
      }
      case 'GET_EVALUATION_FORM_DATA':  {
        return `/api/usp/AquAAContactFormDetails?contactid=${items.contactId}&ContactFormID=${items.contactFormID}&CountryID=${items.countryID}`;
      }
      case 'UPDATE_EVALUATION_FORM_DATA':  {
        return `/api/usp/AquAAEvaluations`;
      }
      case 'GET_SAVED_EVALUATIONS_DATA':  {
        return `/api/usp/AQuAAGetSavedEvaluations`;
      }
      case 'GET_SUBMITTED_EVALUATIONS_DATA':  {
        return `/api/usp/AQuAAGetSubmittedEvaluations`;
      }
      case 'GET_SAVED_EVALUATION_FORM_DATA':  {
        return `/api/usp/AQuAAGetEvaluationsByContactID?EvaluationID=${items.evaluationId}`;
      }
      case 'GET_AQUAA_NONASD_ACCOUNTS_DATA':  {
        return `/api/usp/AQuAANonASDGetAccounts`;
      }
      case 'GET_AQUAA_NONASD_CHANNELS_DATA':  {
        return `/api/usp/AQuAANonASDGetChannels?AccountID=${items.account}&Location=${items.location}`;
      }
      case 'GET_AQUAA_NONASD_LOCATIONS_DATA':  {
        return `/api/usp/AQuAANonASDGetLocation?AccountID=${items.account}`;
      }
      case 'GET_AQUAA_NONASD_LANGUAGES_DATA':  {
        return `/api/usp/AQuAANonASDGetLanguages?AccountID=${items.account}&Location=${items.location}`;
      }
      case 'GET_AQUAA_NONASD_AGENTS_DATA':  {
        return `/api/usp/AQuAANonASDGetAgents?accountid=${items.email}`;
      }
      case 'GET_ADDITIONAL_RECIPIENTS':  {
        return `/api/usp/AQuAAGetReceipants?email=${items.email}`;
      }
      case 'GET_NONASD_EVALUATION_FORM_DATA':  {
        return `/api/usp/AQuAANonASDContactFormDetails?AccountID=${items.account}&Agent=${items.agent}&Channel=${items.channel}&Language=${items.language}&Sitename=${items.location}&ContactFormID=${items.contactTypeID}`;
      }
      case 'GET_AGENT_EVALUATIONS_DATA':  {
        return `/api/usp/AQuAAGetAgentEvaluations`;
      }
      case 'GET_AQUAA_ADMIN_ACCOUNTS_DATA':  {
        return `/api/usp/AQuAAGetInsightAccounts`;
      }
      case 'GET_AQUAA_ADMIN_ACCOUNTS_TABLE_DATA':  {
        return `/api/usp/AQuAAAdminGetAccounts`;
      }
      case 'GET_AQUAA_ADMIN_CHANNELS_DATA':  {
        return `/api/usp/AQuAAAdminGetChannel`;
      }
      case 'GET_AQUAA_ADMIN_CONTACTTYPE_TABLE_DATA':  {
        return `/api/usp/AQuAAAdminGetContacForms`;
      }
      case 'UPDATE_AQUAA_ADMIN_ACCOUNT_DATA':  {
        return `/api/usp/AQuAANewAccount`;
      }
      case 'UPDATE_AQUAA_ADMIN_CONTACTTYPE_DATA_START':  {
        return `/api/usp/AQuAANewContactTypeForm`;
      }
      case 'GET_AQUAA_QUESTION_ASSESSMENTS_DATA':  {
        return `/api/usp/AQuAAGetAssessments`;
      }
      case 'GET_AQUAA_ADMIN_QUESTIONS_TABLE_DATA':  {
        return `/api/usp/AQuAAGetQuestion`;
      }
      case 'UPDATE_AQUAA_ADMIN_QUESTIONS_DATA':  {
        return `/api/usp/AQuAANewQuestionAssessments`;
      }
      case 'UPDATE_AQUAA_ACKNOWLEDGEMENT_DATA':  {
        return `/api/usp/AgentResponse`;
      }
      case 'GET_AQUAA_MAPPING_ACCOUNTS':  {
        return `/api/usp/AQuAAMappingGetAccounts`;
      }
      case 'GET_AQUAA_MAPPING_CONTACTTYPE_FORMS':  {
        return `/api/usp/AQuAAMappingGetContactFormType`;
      }
      case 'GET_AQUAA_MAPPING_COUNTRIES':  {
        return `/api/usp/AQuAAMappingGetCountry?Customer=${items.account}`;
      }
      case 'GET_AQUAA_MAPPING_SECTIONS':  {
        return `/api/usp/AQuAAMappingGetSections`;
      }
      case 'GET_AQUAA_MAPPING_QUESTIONS':  {
        return `/api/usp/AQuAAMappingGetQuestions?Question=${items.question}`;
      }
      case 'GET_AQUAA_MAPPING_PARAMETERTYPE':  {
        return `/api/usp/AQuAAMappingGetParameterType`;
      }
      case 'UPDATE_AQUAA_MAPPING_DATA':  {
        return `/api/usp/AQuAAMapping`;
      }
      case 'GET_AQUAA_EVALUATIONS_DELETE':  {
        return `/api/usp/AQuAAGetEvaluationsForDelete?Parameter=${items.parameter}&Value=${items.value}&RoleId=${items.roleid}`;
      }
      case 'UPDATE_AQUAA_EVALUATIONS_DELETE':  {
        return `/api/usp/DeleteAquAAEvaluations`;
      }
      case 'GET_AQUAA_VALIDATE_TICKET_NO':  {
        return `/api/usp/AQUAACheckTicketNumber?TicketNumber=${items.ticketNo}`;
      }
      case 'GET_AQUAA_ICED_AGENTS':  {
        return `/api/usp/AQuAAGetICEDAgents`;
      }
      case 'GET_AQUAA_ICED_ACCOUNTS':  {
        return `/api/usp/AQuAAGetICEDAccounts`;
      }
      case 'GET_AQUAA_ICED_TABLE_DATA':  {
        return `/api/usp/AQuAAGetICEDData?Agent=${items.Agent}&Account=${items.Account}&StartDT=${items.StartDT}&EndDT=${items.EndDT}&TicketNumber=${items.TicketNumber}`;
      }
      case 'GET_AQUAA_ICED_L1_CATEGORY':  {
        return `/api/usp/AQuAAGetLOneCategory`;
      }
      case 'GET_AQUAA_ICED_L2_CATEGORY':  {
        return `/api/usp/AQuAAGetLTwoCategory`;
      }
      case 'UPDATE_AQUAA_ICED_DATA':  {
        return `/api/usp/AQuAAICEDData`;
      }
      case 'GET_AQUAA_ICED_EVALUATIONS_DATA':  {
        return `/api/usp/AQuAAGetICEDEvaluations?RoleId=${items.roleId}`;
      }
      case 'GET_ACCOUNT_EVALUATOR_ACCOUNTS_DATA':  {
        return `/api/usp/AQuAA_AccEvl_Mapping_GetAccounts?RoleId=${items.roleId}`;
      }
      case 'GET_ACCOUNT_EVALUATOR_EVALUATORS_DATA':  {
        return `/api/usp/AQuAA_AccEvl_Mapping_GetEvaluators?RoleId=${items.roleId}`;
      }
      case 'GET_ACCOUNT_EVALUATOR_TABLE_DATA':  {
        return `/api/usp/AQuAAMappedAccEvl?AccountID=${items.accountId}&EvaluatorID=${items.evaluatorId}&RoleId=${items.roleId}`;
      }
      case 'UPDATE_ACCOUNT_EVALUATOR_MAPPING_DATA':  {
        return `/api/usp/AQuAAAccountEvaluatorMapping`;
      }
      case 'UPDATE_NEW_EVALUATOR_DATA':  {
        return `/api/usp/AQuAANewEvaluator`;
      }
      case 'GET_ACCOUNT_EVALUATOR_USERS_DATA':  {
        return `/api/usp/AQuAA_AccEvl_GetUsers?Agent=${items.agent}`;
      }
      case 'GET_ICED_REPORTS_ACCOUNTS':  {
        return `/api/usp/ICEDGetAccountsReports?RoleId=${items.roleId}`;
      }
      case 'GET_ICED_MASTER_DATA':  {
        return `/api/usp/ICEDGetMasters?RoleId=${items.roleId}`;
      }
      case 'UPDATE_ICED_DATA':  {
        return `/api/usp/ICEDTickets`;
      }
      case 'GET_ICED_TABLE_DATA':  {
        return `/api/usp/ICEDGetTicketsByUser`;
      }
      case 'UPDATE_SUBMITTED_COMMENTS_DATA':  {
        return `api/usp/AquAAUpdateOverAllComments`;
      }
      case 'GET_RECOMMENDATIONS_TABLE_DATA':  {
        return `/api/usp/AQuAARecomendations?Recommendation=${items.Recommendation}&Status=${items.Status}&AssignedToMe=${items.AssignedToMe}`;
      }
      case 'UPDATE_TRAINING_ASSIGNMENT_DATA':  {
        return `api/usp/AquAATrainingAssignment`;
      }
      case 'UPDATE_TRAINING_COMMENTS_DATA':  {
        return `api/usp/AquAAActionComments`;
      }
      case 'GET_TRAINER_TABLE_DATA':  {
        return `/api/usp/AQuAAAgentTrainings`;
      }
      case 'UPDATE_AGENT_TRAINING_COMMENTS_DATA':  {
        return `api/usp/AQUAATrainingAcknowledge`;
      }
      case 'GET_RECOMMENDATIONS_DROPDOWN_DATA':  {
        return `/api/usp/AQuAAGetMasters`;
      }
      case 'UPDATE_EF_MISSING_DATA_START':  {
        return `/api/usp/AquAATestingEvaluations`;
      }
      default: {}
    }
  }
  export default AquaaURLs;


 